<script setup lang="ts">
import {computed} from 'vue'

const props = defineProps<{
  position: 'top' | 'bottom'
}>()

const gradientAngle = computed(() => (props.position === 'top' ? 'to bottom' : 'to top'))
</script>

<template>
  <div class="relative h-0 w-full">
    <div
      :class="`absolute inset-0 mx-auto h-[0.2px] w-2/3 bg-gradient-to-r from-transparent via-main-500 to-transparent`"
      style="box-shadow: 0 0 6px rgba(0, 150, 136, 0.5)"
    ></div>

    <div
      class="absolute inset-0 mx-auto h-8 w-full"
      :style="{
        background: `linear-gradient(${gradientAngle}, rgba(0, 150, 136, 0.5), rgba(0, 150, 136, 0))`,
        maskImage:
          props.position === 'top'
            ? 'radial-gradient(circle, rgba(0, 0, 0, 0.3) 10%, rgba(0, 0, 0, 0) 100%)'
            : 'radial-gradient(circle, rgba(0, 0, 0, 0.3) 25%, rgba(0, 0, 0, 0) 100%)',
      }"
    ></div>
  </div>
</template>
